export default {
    ADD_USERINFO: (state, info) => {
        state.userInfo = info;
    },
    SET_USERINFO_DISPLAY_NAME: (state, info) => {
        state.userInfo.username = info;
    },
    SET_EMPLOYEE_TIMELINE: (state, payload) => {
        state.employeeTimeline = payload;
    },
    SET_LOGIN_STATE: (state, loggedIn) => {
        state.loggedInState = loggedIn;
    },
    SET_AUTH_HEADER: (state, token) => {
        state.authHeader.headers = { 'id-token': token };
    },
    SET_COUNTRY_LIST: (state, countries) => {
        state.countries = countries;
    },
    SET_COMPANY_INFO: (state, companyInfo) => {
        state.companyInfo = companyInfo;
    },
    SET_COMPANY: (state, company) => {
        state.company = company;
    },
    SET_COMPANY_TIMELINE: (state, payload) => {
        state.companyTimeline = payload;
    },
    SET_ME: (state, me) => {
        state.me = me;
    },
    SET_DASHBOARD: (state, dashboard) => {
        state.dashboard = dashboard;
    },
    SET_CALENDAR_INFO: (state, calendarInfo) => {
        state.calendar.info = calendarInfo;
    },
    SET_CALENDAR_EVENTS: (state, payload) => {
        state.calendar.today = payload.today;
        state.calendar.events = payload.events;
    },
    SET_LOCATIONS: (state, payload) => {
        state.locations = payload;
    },
    SET_LOCATION: (state, location) => {
        state.locations.push(location);
    },
    DELETE_LOCATION: (state, id) => {
        state.locations = state.locations.filter(el => el.id !== id);
    },
    UPDATE_LOCATION: (state, location) => {
        state.locations = state.locations.map(el => {
            if (el.id == location.id) {
                return location;
            }
            return el;
        });
    },
    SET_DEPARTMENTS: (state, payload) => {
        state.departments = payload;
    },
    DELETE_DEPARTMENT: (state, id) => {
        state.departments = state.departments.filter(el => el.id !== id);
    },
    UPDATE_DEPARTMENT: (state, department) => {
        state.departments = state.departments.map(el => {
            if (el.id == department.id) {
                return department;
            }
            return el;
        });
    },
    SET_WORKFLOWS: (state, payload) => {
        state.workflows = payload;
    },
    UPDATE_WORKFLOW: (state, workflow) => {
        state.workflows = state.workflows.map(el => {
            if (el.id == workflow.id) {
                return workflow;
            }
            return el;
        });
    },
    DELETE_WORKFLOW: (state, id) => {
        state.workflows = state.workflows.filter(el => el.id != id);
    },
    SET_BO_ITEMS: (state, payload) => {
        state.backofficeItems = payload;
    },
    SET_BO_ITEM: (state, item) => {
        state.backofficeItems.push(item);
    },
    DELETE_BO_ITEM: (state, id) => {
        state.backofficeItems = state.backofficeItems.filter(el => el.id != id);
    },
    DELETE_LEAVE_TYPES: (state, id) => {
        state.leaveTypes = state.leaveTypes.filter(el => el.id != id);
    },
    SET_LEAVE_TYPES: (state, leaveTypes) => {
        state.leaveTypes = leaveTypes;
    },
    SET_ADMIN_LEAVE_TYPES: (state, payload) => {
        state.adminLeavePolicies = payload;
    },
    SET_MARKETPLACE_OFFER: (state, payload) => {
        state.marketplaceOffers = payload;
    },
    SET_MARKETPLACE_SEARCH: (state, search) => {
        state.marketplaceSearch = search;
    },
    SET_TIMEOFF_LIST: (state, payload) => {
        state.timeOffs = payload;
    },
    DELETE_TIMEOFF: (state, id) => {
        state.timeOffs = state.timeOffs.filter(el => {
            return el.id != id;
        });
    },

    SET_ANNOUNCEMENTS: (state, payload) => {
        state.announcements = payload;
    },
    DELETE_ANNOUNCEMENT: (state, id) => {
        state.announcements = state.announcements.map(el => el.id != id);
    },

    SET_AVAILABLE_TIMEOFFS: (state, payload) => {
        state.availableTimeoffs = payload;
    },
    SET_MY_TIMEOFFS: (state, payload) => {
        state.myTimeoffs = payload;
    },
    SET_EVERYTHING: (state, payload) => {
        state.everything = payload;
    },
    EMP_POP_SHOW: (status) => {
        status.empPopUpShown++;
    },
    SET_PROVIDER: (state, payload) => {
        state.provider = payload;
    },
    SET_PROVIDER_BENEFITS: (state, payload) => {
        state.providerBenefits = payload
    },
    SET_ACCESS_REQUESTS: (state,payload) => {
        state.accessRequests = payload
    },

};